var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7418",
    "data-name": "Rectangle 7418",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11062",
    "data-name": "Path 11062",
    d: "M13.6,10.9c.1.1.2.1.4.1h7a.945.945,0,0,0,1-1c0-.2,0-.3-.1-.4l-3.5-7A1.012,1.012,0,0,0,17,2.2c-.1.1-.3.2-.4.4l-3.5,7A1.062,1.062,0,0,0,13.6,10.9Zm3.9-5.7L19.4,9H15.6ZM6.5,2A4.5,4.5,0,1,0,11,6.5,4.481,4.481,0,0,0,6.5,2Zm0,7A2.5,2.5,0,1,1,9,6.5,2.476,2.476,0,0,1,6.5,9Zm4.2,4.3h0a.967.967,0,0,0-1.4,0h0L6.5,16.1,3.7,13.3a.967.967,0,0,0-1.4,0,.967.967,0,0,0,0,1.4l2.8,2.8L2.3,20.3a.967.967,0,0,0,0,1.4.967.967,0,0,0,1.4,0h0l2.8-2.8,2.8,2.8a.99.99,0,0,0,1.4-1.4L7.9,17.5l2.8-2.8A.967.967,0,0,0,10.7,13.3ZM21,13H14a.945.945,0,0,0-1,1v7a.945.945,0,0,0,1,1h7a.945.945,0,0,0,1-1V14A.945.945,0,0,0,21,13Zm-1,7H15V15h5Z",
    fill: "#02466a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.be0faedea55e38448c3d6536a2621323.svg";
export { ForwardRef as ReactComponent };